<template>
<SvgIconBase :svgImgPath="require(`./../../assets/weather_icons/${WeatherIconName}.svg`)" :Width="width" :Height="heigth"></SvgIconBase>
</template>

<script>
import SvgIconBase from "@/components/berriesRoster/SvgIconBase.vue"

export default {
    props: ['WeatherIconName', 'width', 'heigth'],
    components: {
        SvgIconBase
    }
}
</script>
